import { Component, Input, OnInit } from '@angular/core';
import { SearchStateService } from '@core/services';
import { MealPlanDetail } from '@core/models/MealPlan/MealPlan.model';
import { PaymentMethodsCode } from '@shared/enums/payment-methods-code.enum';
import { ChargesComponent } from '../../charges/charges.component';
import { PaymentAdviseInfoComponent } from '../payment-advise-info/payment-advise-info.component';
import { MbBadgeModule, MbIconModule } from '@am/moebius';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'payment-advise',
    templateUrl: './payment-advise.component.html',
    styleUrls: ['./payment-advise.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        MbBadgeModule,
        MbIconModule,
        PaymentAdviseInfoComponent,
        ChargesComponent,
        NgClass,
    ],
})
export class PaymentAdviseComponent implements OnInit {
  @Input() set rate(rate: any) {
    this.inputRate = rate;
  }

  @Input() set argentina(isArgentina: boolean) {
    this.isArgentina = isArgentina;
  }

  @Input()
  isMobile = false;

  @Input()
  isExperts = false;

  inputRate: any;

  isArgentina = false;

  public readonly PAYMENT_METHOD_CODES = PaymentMethodsCode;

  public isCurrencyUSD = false;

  constructor(private searchState: SearchStateService) {}

  ngOnInit(): void {
    this.isCurrencyUSD = this.searchState.getCurrencyCode() === 'USD';
  }

  public get paymentMethod(): MealPlanDetail {
    return this.inputRate.payment_method;
  }
}
